// Build de desenvolvimento (npm run build:dev / ng serve) — usado em DEV.
export const environment = {
  production: false,
  name: 'DEV',
  apiBaseUrl: '/api',
};
